import { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext({ lang: "en", setLang: () => {}, t: {} });

export const STR = {
  en: {
    nav: { history: "History", tour: "Tour 2027", lineup: "Lineup", producer: "Producer", rider: "Tech Rider", book: "Book Now" },
    hero: {
      kicker: "Gothic Rock × Pop × Wave — Est. 2004 — Dresden / Lusatia",
      para: "CRAYFOX — rock, wave and pure live energy. Down-tuned riffs meet danceable wave synths and an uncompromising live show. CRAYFOX blends powerful rock with elegant, electronic soundscapes for an intense concert experience — perfect for festivals, clubs and events. Looking for the right sound for your stage? Bring CRAYFOX to your event. Send your booking enquiry now and let's make something happen together.",
      book: "Book the Band",
      rider: "View Tech Rider",
      videoCaption: "Live Promo — unmute for sound",
      fadeIn: "In",
      fadeOut: "Out",
    },
    marquee: [
      "CRAYFOX LIVE",
      "ROCK × POP-METAL × WAVE",
      "BOOKINGS OPEN 2026/27",
      "STAGE ON FIRE",
      "RAW POWER — UNFORGIVING ENERGY",
    ],
    history: {
      kicker: "The History // Since 2004",
      title: "A Sound That Hits. Songs That Don't Let Go.",
      p1: "CRAYFOX is a German rock, pop-metal and wave band from the Dresden and Lusatia area, founded in 2004 — grown from a late-2003 studio project into a live band with over two decades of stage history.",
      p2: "Blending melodic rock, pop-metal hooks and cold wave synths, CRAYFOX built a reputation for shows that feel less like concerts and more like controlled detonations — pyro, strobes and a wall of sound that leaves no one standing still.",
      quote: "“This band is simply unbeatable LIVE — Bea's voice and the powerful wall of sound are impressive.”",
      quoteBy: "— Art of Nero · Rock im Wald, Ohorn 2026",
      timeline: [
        { year: "2004", text: "Founded in the Dresden / Lusatia area — grown from a late-2003 studio project into a live band." },
        { year: "2006", text: "Debut album “Rise” — nationwide and international shows, highlighted by the Rockharz Festival." },
        { year: "2010", text: "Creative break." },
        { year: "2015", text: "The band project continues." },
        { year: "2026", text: "Booking now open for the 2026/27 club & festival cycle." },
      ],
    },
    tour: {
      kicker: "Live // On Stage",
      title: "CRAYFOX Reloaded Tour 2027",
      venueTba: "Venue TBA",
      filters: { all: "All Dates", confirmed: "Confirmed", festival: "Festivals", open: "Open Slots" },
      status: { confirmed: "Confirmed", festival: "Festival", open: "Slot Open" },
      request: "Request this date",
      emptyPre: "No dates in this category yet —",
      emptyCta: "ask for yours",
      missing: "Your city missing?",
      askCta: "Ask for a date",
      flexible: "— routing is flexible.",
    },
    lineup: {
      kicker: "The Lineup // Four Pieces",
      title: "The Players",
      roles: ["Lead Vocals", "Lead Guitar + Vocals", "Bass & Backing Vocals", "Drums & Triggers"],
      stages: ["Center Stage", "Stage Left", "Stage Right", "Drum Riser"],
      producerTitle: "The Producer",
      producerRole: "Music & Video Producer, Composer, Arranger",
      producerBio: "Business administration studies at IFB Leipzig, audio engineering studies at SEA Berlin. Producer for Sony Music (gold album 2015), Telamo and Ariola.",
    },
    rider: {
      kicker: "Tech Rider // Stage Plan",
      title: "Zero-Friction Tech",
      banner: "16 Channels — 4 Monitor Mixes — Own Backline",
      print: "Print / PDF",
      inputList: "Input List",
      headers: ["CH", "Source", "Mic / DI", "Notes"],
      monitoring: "Monitoring",
      pa: "PA & Power",
      backline: "Backline & Production",
      stagePlan: "Stage Plan",
      monitors: [
        "Mix 1 — Lead Vocals: center wedge or IEM (own Sennheiser EW IEM rack)",
        "Mix 2 — Guitar: stage-left wedge, vocal-heavy",
        "Mix 3 — Bass: stage-right wedge, kick + vox focus",
        "Mix 4 — Drums: drumfill + sidefill, click via IEM (own splitter)",
      ],
      paItems: [
        "PA sized to venue capacity; min. 2x 18\" subs per side for 300+ cap rooms",
        "Digital FOH desk: X32 / M32 / SQ-5 or better",
        "230V / 16A power drops: stage left, stage right, drum riser",
        "Stage min. 6m x 4m; drum riser 3m x 2m (min. 40cm height)",
        "Lighting: we travel with a floor package — strobes & red wash very welcome",
      ],
      backlineItems: [
        "Full backline travels with the band (amps, drums, IEM rack)",
        "For fly-dates / festivals: drum kit + bass amp on request",
        "Set length: 45–90 min; changeover: 25 min with own crew",
        "Pyro (cold spark fountains) available for outdoor / approved venues",
      ],
    },
    booking: {
      kicker: "Booking // Promoters Only",
      title: "Bring the Spectacle to Your Stage",
      pitch: "One form, no agency maze. Tell us when and where — we handle the rest: own backline, own crew, a clear stage plan and a show your audience will talk about.",
      bullets: [
        "Reply within 48 hours, guaranteed",
        "Club shows, festivals, open airs & support slots",
        "Set length 45–90 min, changeover in 25 min",
        "Cold-spark pyro available for approved venues",
      ],
      direct: "Direct contact",
      labels: {
        name: "Your Name *", email: "E-Mail *", phone: "Phone", date: "Event Date *",
        venue: "Venue *", city: "City *", country: "Country", type: "Event Type *",
        audience: "Expected Audience", budget: "Budget Range", message: "Message",
      },
      placeholders: {
        name: "Alex Promoter", email: "you@promotion.com", phone: "+49 ...",
        venue: "Matrix", city: "Bochum", country: "Germany",
        message: "Tell us about your event, stage size, curfew, other bands on the bill…",
      },
      select: "Select…",
      types: [
        { v: "Club Show", l: "Club Show" }, { v: "Festival", l: "Festival" },
        { v: "Open Air", l: "Open Air" }, { v: "Private Event", l: "Private Event" },
        { v: "Support Slot", l: "Support Slot" },
      ],
      audiences: [
        { v: "Under 200", l: "Under 200" }, { v: "200 – 500", l: "200 – 500" },
        { v: "500 – 1.500", l: "500 – 1.500" }, { v: "1.500 – 5.000", l: "1.500 – 5.000" },
        { v: "5.000+", l: "5.000+" },
      ],
      budgets: [
        { v: "Under 1.000 €", l: "Under 1.000 €" }, { v: "1.000 – 2.500 €", l: "1.000 – 2.500 €" },
        { v: "2.500 – 5.000 €", l: "2.500 – 5.000 €" }, { v: "5.000 € +", l: "5.000 € +" },
        { v: "Let's talk", l: "Let's talk" },
      ],
      submit: "Send Booking Enquiry",
      sending: "Sending…",
      note: "No spam, no obligation — just a fast answer.",
      toastOk: "Booking enquiry sent — we reply within 48 hours.",
      toastErr: "Something went wrong — please email us directly.",
    },
    contact: {
      cta: "Email me",
      title: "Direct contact",
      note: "Write to us — we reply within 48 hours.",
      open: "Open mail app",
      copy: "Copy address",
      copied: "Copied!",
    },
    footer: {
      tagline: "Raw power. Unforgiving energy. Book the spectacle.",
      rights: "© 2026 CRAYFOX — All rights reserved",
      genre: "Gothic Rock × Pop × Wave — Germany",
    },
  },
  de: {
    nav: { history: "Geschichte", tour: "Tour 2027", lineup: "Lineup", producer: "Der Produzent", rider: "Tech Rider", book: "Jetzt buchen" },
    hero: {
      kicker: "Gothic Rock × Pop × Wave — Gegr. 2004 — Dresden / Lausitz",
      para: "CRAYFOX – Rock, Wave und pure Live-Energie. Tief gestimmte Riffs treffen auf tanzbare Wave-Synths und eine kompromisslose Live-Show. CRAYFOX verbindet druckvollen Rock mit eleganten, elektronischen Klangwelten zu einem intensiven Konzerterlebnis – perfekt für Festivals, Clubs und Events. Du suchst den passenden Sound für deine Bühne? Dann hol dir CRAYFOX auf dein Event. Sende jetzt deine Booking-Anfrage und lass uns gemeinsam etwas bewegen.",
      book: "Band buchen",
      rider: "Tech Rider ansehen",
      videoCaption: "Live-Promo — Ton einschalten",
      fadeIn: "Fade-in",
      fadeOut: "Fade-out",
    },
    marquee: [
      "CRAYFOX LIVE",
      "ROCK × POP-METAL × WAVE",
      "BUCHUNGEN OFFEN 2026/27",
      "STAGE ON FIRE",
      "RAW POWER — UNNACHGIEIGE ENERGIE",
    ],
    history: {
      kicker: "Die Geschichte // Seit 2004",
      title: "Ein Sound, der trifft. Songs, die nicht loslassen.",
      p1: "CRAYFOX ist eine deutsche Rock-, Pop-Metal- und Wave-Band aus dem Raum Dresden und der Lausitz, gegründet 2004 — aus einem Studioprojekt von Ende 2003 zu einer Live-Band mit über zwei Jahrzehnten Bühnengeschichte gewachsen.",
      p2: "Mit melodischem Rock, Pop-Metal-Hooks und kalten Wave-Synths hat sich CRAYFOX einen Ruf für Shows erarbeitet, die weniger wie Konzerte wirken und mehr wie kontrollierte Detonationen — Strobo, Rauch und eine Wand aus Sound, die niemanden stillstehen lässt.",
      quote: "„Diese Band ist LIVE einfach unschlagbar — Bea's Stimme und der kraftvolle Soundgarden sind beeindruckend.“",
      quoteBy: "— Art of Nero · Rock im Wald, Ohorn 2026",
      timeline: [
        { year: "2004", text: "Gegründet im Raum Dresden / Lausitz — aus einem Studioprojekt von Ende 2003 zur Live-Band gewachsen." },
        { year: "2006", text: "Debütalbum „Rise“ — bundesweite und internationale Auftritte, als Highlight das Rockharz Festival." },
        { year: "2010", text: "Kreative Pause." },
        { year: "2015", text: "Fortführung des Bandprojektes." },
        { year: "2026", text: "Buchungen für den Club- & Festival-Zyklus 2026/27 sind offen." },
      ],
    },
    tour: {
      kicker: "Live // Auf der Bühne",
      title: "CRAYFOX Reloaded-Tour 2027",
      venueTba: "Venue folgt",
      filters: { all: "Alle Termine", confirmed: "Bestätigt", festival: "Festivals", open: "Freie Slots" },
      status: { confirmed: "Bestätigt", festival: "Festival", open: "Slot frei" },
      request: "Termin anfragen",
      emptyPre: "Noch keine Termine in dieser Kategorie —",
      emptyCta: "frag deinen an",
      missing: "Deine Stadt fehlt?",
      askCta: "Frag einen Termin an",
      flexible: "— das Routing ist flexibel.",
    },
    lineup: {
      kicker: "Das Lineup // Vier Musiker",
      title: "Die Musiker",
      roles: ["Gesang", "Lead-Gitarre + Vocal", "Bass & Backing-Vocals", "Schlagzeug & Trigger"],
      stages: ["Bühnenmitte", "Bühne links", "Bühne rechts", "Drum-Podest"],
      producerTitle: "Der Produzent",
      producerRole: "Musik- und Videoproduzent, Komponist, Arrangeur",
      producerBio: "Studium Betriebswirtschaft IFB Leipzig, Studium Audio Engineering SEA Berlin. Produzent für Sony Music (Goldenes Album 2015), Telamo und Ariola.",
    },
    rider: {
      kicker: "Tech Rider // Bühnenplan",
      title: "Technik ohne Umwege",
      banner: "16 Kanäle — 4 Monitor-Mixe — Eigenes Backline",
      print: "Drucken / PDF",
      inputList: "Input-Liste",
      headers: ["CH", "Quelle", "Mikro / DI", "Notizen"],
      monitoring: "Monitoring",
      pa: "PA & Strom",
      backline: "Backline & Produktion",
      stagePlan: "Bühnenplan",
      monitors: [
        "Mix 1 — Lead-Gesang: Wedge Mitte oder IEM (eigenes Sennheiser-EW-IEM-Rack)",
        "Mix 2 — Gitarre: Wedge bühnenlinks, gesangslastig",
        "Mix 3 — Bass: Wedge bühnenrechts, Fokus Kick + Vox",
        "Mix 4 — Drums: Drumfill + Sidefill, Click via IEM (eigener Splitter)",
      ],
      paItems: [
        "PA passend zur Venue-Kapazität; mind. 2x 18\"-Subs pro Seite ab 300 Personen",
        "Digitaler FOH: X32 / M32 / SQ-5 oder besser",
        "230V / 16A Strom: Bühne links, Bühne rechts, Drum-Podest",
        "Bühne mind. 6m x 4m; Drum-Podest 3m x 2m (mind. 40cm hoch)",
        "Licht: Eigenes Floor-Package reist mit — Strobes & rote Flächen sehr willkommen",
      ],
      backlineItems: [
        "Komplettes Backline reist mit der Band (Amps, Drums, IEM-Rack)",
        "Fly-Dates / Festivals: Drumkit + Bass-Amp auf Anfrage",
        "Setlänge: 45–90 Min; Umbau: 25 Min mit eigener Crew",
        "Kalte Funkenfontänen (Cold Spark) für Outdoor / freigegebene Venues verfügbar",
      ],
    },
    booking: {
      kicker: "Booking // Für Veranstalter",
      title: "Hol das Spektakel auf deine Bühne",
      pitch: "Ein Formular, kein Agentur-Labyrinth. Sag uns wann und wo — wir erledigen den Rest: eigenes Backline, eigene Crew, ein klarer Bühnenplan und eine Show, über die dein Publikum reden wird.",
      bullets: [
        "Antwort innerhalb von 48 Stunden, garantiert",
        "Clubshows, Festivals, Open Airs & Support-Slots",
        "Setlänge 45–90 Min, Umbau in 25 Min",
        "Kalte Funkenpyro für freigegebene Venues verfügbar",
      ],
      direct: "Direkter Kontakt",
      labels: {
        name: "Dein Name *", email: "E-Mail *", phone: "Telefon", date: "Datum *",
        venue: "Venue *", city: "Stadt *", country: "Land", type: "Art der Veranstaltung *",
        audience: "Erwartetes Publikum", budget: "Budgetrahmen", message: "Nachricht",
      },
      placeholders: {
        name: "Alex Veranstalter", email: "you@promotion.com", phone: "+49 ...",
        venue: "Matrix", city: "Bochum", country: "Deutschland",
        message: "Erzähl uns von deinem Event: Bühnengröße, Curfew, andere Bands im Billing…",
      },
      select: "Bitte wählen…",
      types: [
        { v: "Club Show", l: "Clubshow" }, { v: "Festival", l: "Festival" },
        { v: "Open Air", l: "Open Air" }, { v: "Private Event", l: "Private Veranstaltung" },
        { v: "Support Slot", l: "Support-Slot" },
      ],
      audiences: [
        { v: "Under 200", l: "Unter 200" }, { v: "200 – 500", l: "200 – 500" },
        { v: "500 – 1.500", l: "500 – 1.500" }, { v: "1.500 – 5.000", l: "1.500 – 5.000" },
        { v: "5.000+", l: "5.000+" },
      ],
      budgets: [
        { v: "Under 1.000 €", l: "Unter 1.000 €" }, { v: "1.000 – 2.500 €", l: "1.000 – 2.500 €" },
        { v: "2.500 – 5.000 €", l: "2.500 – 5.000 €" }, { v: "5.000 € +", l: "5.000 € +" },
        { v: "Let's talk", l: "Sprechen wir drüber" },
      ],
      submit: "Anfrage senden",
      sending: "Wird gesendet…",
      note: "Kein Spam, keine Verpflichtung — nur eine schnelle Antwort.",
      toastOk: "Anfrage gesendet — wir antworten innerhalb von 48 Stunden.",
      toastErr: "Etwas ist schiefgelaufen — schreib uns bitte direkt per E-Mail.",
    },
    contact: {
      cta: "E-Mail schreiben",
      title: "Direkter Kontakt",
      note: "Schreib uns — wir antworten innerhalb von 48 Stunden.",
      open: "Mail-App öffnen",
      copy: "Adresse kopieren",
      copied: "Kopiert!",
    },
    footer: {
      tagline: "Raw Power. Unnachgiebige Energie. Buche das Spektakel.",
      rights: "© 2026 CRAYFOX — Alle Rechte vorbehalten",
      genre: "Gothic Rock × Pop × Wave — Deutschland",
    },
  },
};

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("crayfox-lang") || "de");
  useEffect(() => {
    localStorage.setItem("crayfox-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return <LangContext.Provider value={{ lang, setLang, t: STR[lang] }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
